const AlertMessage = ({ title, message, typeAlert }) => {
    return (
        <div className={`alert alert-${typeAlert} alert-dismissible`}>
            {/*<button type="button" className="close" data-dismiss="alert" aria-hidden="true">&times;</button>*/}
            <h5><i className="icon fas fa-exclamation-triangle"></i> {title}</h5>
            {message}
        </div>
    );
}

export default AlertMessage;